import { identityScript, viewDocument } from "./document.js";

// `update_note` proposes; this view is where the clinician edits and decides (FR-6). Save sends the COMPLETE edited
// note to the app-only `apply_note_draft` in the scope the payload carried; Discard writes nothing.
const body = `<div id="root"><p class="muted">Loading the proposed note…</p></div>`;
const script = `${identityScript}
var FIELDS = [["hpi","History of present illness"],["exam","Physical exam"],["assessment","Assessment and plan"],["instructions","Patient instructions"]];
var FOLLOWUPS = ["3 months","2 weeks","1 month","6 months","As needed"];
var root = document.getElementById("root"), state = null, requestId = null, done = false;
function render() {
  var p = state, locked = p.encounter.signed || done;
  var html = identityHtml(p.patient, p.encounter, "Proposed by Dobby; nothing is saved until you save.");
  FIELDS.forEach(function (f) {
    var proposed = p.proposed[f[0]], current = proposed !== undefined ? proposed : p.baseline[f[0]];
    html += '<label for="f-' + f[0] + '">' + f[1] + (proposed !== undefined && proposed !== p.baseline[f[0]] ? ' <span class="badge">changed</span>' : '') + '</label>' +
      '<textarea id="f-' + f[0] + '" maxlength="8000"' + (locked ? ' disabled' : '') + '>' + view.esc(current) + '</textarea>';
    if (proposed !== undefined && proposed !== p.baseline[f[0]]) html += '<div class="was">Currently: ' + view.esc(p.baseline[f[0]] || "(empty)") + '</div>';
  });
  var follow = p.proposed.followup !== undefined ? p.proposed.followup : p.baseline.followup;
  html += '<label for="f-followup">Follow-up</label><select id="f-followup"' + (locked ? ' disabled' : '') + '>' +
    FOLLOWUPS.map(function (v) { return '<option' + (v === follow ? ' selected' : '') + '>' + view.esc(v) + '</option>'; }).join("") + '</select>';
  html += '<div class="actions"><button id="discard"' + (done ? ' disabled' : '') + '>Discard</button><button id="save" class="primary"' + (locked ? ' disabled' : '') + '>Save note</button></div>';
  root.innerHTML = html;
  if (p.encounter.signed) showStatus(root, "This encounter is signed, so the note can no longer change.", true);
  document.getElementById("discard").onclick = function () { done = true; render(); showStatus(root, "Discarded. Nothing was written."); };
  document.getElementById("save").onclick = save;
  view.reportSize();
}
/** The note the proposal replaces: what a re-read compares. */
function baselineOf(p) {
  return FIELDS.map(function (f) { return p.baseline[f[0]]; }).concat(p.baseline.followup).join("\u0000");
}
function save() {
  var note = {};
  FIELDS.forEach(function (f) { note[f[0]] = document.getElementById("f-" + f[0]).value; });
  note.followup = document.getElementById("f-followup").value;
  // Held across a retry of this same attempt, so a lost reply cannot apply the change twice.
  requestId = requestId || view.requestId();
  document.getElementById("save").disabled = true;
  view.callTool("apply_note_draft", {
    patient_id: state.patient.patient_id, encounter_id: state.encounter.id,
    expected_revision: state.encounter.revision, request_id: requestId, note: note
  }).then(function (r) {
    if (!r.ok) {
      if (r.code !== "stale_revision") { document.getElementById("save").disabled = false; showStatus(root, explain(r), true); return; }
      var before = state;
      // Keep what Dobby proposed and what the clinician edited; a section neither touched follows the note as it is now.
      var kept = {};
      Object.keys(note).forEach(function (k) { if (before.proposed[k] !== undefined || note[k] !== before.baseline[k]) kept[k] = note[k]; });
      state = { kind: before.kind, patient: before.patient, encounter: before.encounter, baseline: before.baseline, proposed: note, saved: before.saved };
      done = true; requestId = null; render();
      afterStale(root, "save", before, function () {
        return read("get_encounter", { patient_id: before.patient.patient_id, encounter_id: before.encounter.id }).then(function (d) {
          var e = d.encounter;
          return { revision: e.revision, signed: e.signed, state: { kind: before.kind, patient: before.patient,
            encounter: { id: e.id, revision: e.revision, signed: e.signed }, baseline: e.note, proposed: kept, saved: e.saved } };
        });
      }, baselineOf, function (fresh) { state = fresh; done = false; render(); });
      return;
    }
    done = true;
    state.encounter.revision = r.data.revision;
    state.baseline = note; state.proposed = {};
    render();
    showStatus(root, "Saved. The note is now revision " + r.data.revision + ".");
  });
}
view.onResult(function (data) {
  if (!data || data.kind !== "note_review") { root.textContent = "Nothing to review."; return; }
  state = data; requestId = null; done = false; render();
});
`;
export const noteReviewView = viewDocument("Review note", body, script);
